import { createRouter, createWebHistory } from 'vue-router'
import ContactView from '../views/ContactView.vue'

import RegisterVue from '../views/RegisterView.vue'
import LoginView from '../views/LoginView.vue'
import AdminView from '../admin_views/AdminView.vue'
import UsersView from '../admin_views/ClientsListView.vue'
import DashboardView from '../admin_views/DashboardView.vue'
import UserView from '../admin_views/ClientPage.vue'
import CompanyUserPage from '../admin_views/CompanyUserPage.vue'
import PlatofrmControlView from '../admin_views/PlatformControlView.vue'
import WalletView from '../views/WalletView.vue'
import VerifyView from '../views/VerifyView.vue'

import KYCView from '../views/KycView.vue'
import ResetPasswordView from '../views/ResetPassword.vue'
import SupportTicket from '../views/SupportView.vue'
import TicketView from '../views/TicketView.vue'
import UserManagementView from '../views/UserManagementView.vue'
import SnapshotView from '../views/SnapshotView.vue'
import SubsidiaryView from '../views/SubsidiaryView.vue'
import TermsPage from '../admin_views/TermsPage.vue'
import TermsUser from '../views/TermsUser.vue'

import Logs from '../admin_views/Logs.vue'
import LogsPeriod from '../admin_views/LogsPeriod.vue'

import userViewNormal from '../views/UserView.vue'
import UserProfile from '../views/UserProfile.vue'
import SanctionsView from '../views/SanctionsView.vue'
import SanctionView from '@/views/SanctionView.vue'

import ActionRequired from '@/views/ActionRequired.vue'
import ClientPage from '@/views/ClientPage.vue'

import UserInfo from '@/views/UserInfo.vue'
import FileListView from '@/views/FileListView.vue'
import UsageFIU from '@/views/UsageFIU.vue'
import InvoicesView from '@/views/InvoicesView.vue'


import TaskList from '@/views/TaskList.vue'
import TaskView from '@/views/TaskView.vue'

import DueDiligence from '@/views/DueDiligence.vue'
import DueDiligenceList from '@/views/DueDiligenceList.vue'
import FiuSection from '@/views/FiuSection.vue'
import KYCSection from '@/views/KYCSection.vue'
import DueDiligenceSection from '@/views/DueDiligenceSection.vue'
import SanctionScreeningSection from '@/views/SanctionScreeningSection.vue'

import HomePage from '@/views/HomePage.vue'
import FIUTemplaces from '@/admin_views/FIUTemplaces.vue'
import userFiuTemplates from '@/views/userFiuTemplates.vue'

import PlayerData from '@/components/PlayerData.vue'
import CurrencyView from '@/admin_views/CurrencyView.vue'

import ReportsView from '@/views/Reports.vue'

import DemoPage from '@/views/DemoPage.vue';
import Agreements from '@/views/Agreements.vue';

const routes = [
  {
    path: '/admin',
    name: 'admin',
    component: AdminView,
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: DashboardView,
      },
      {
        path: 'users/:id/',
        name: 'bo_user',
        props: true,
        component: UserView,
      },
      {
        path: 'company-users/:user_id',
        name: 'bo_company_user',
        props: true,
        component: CompanyUserPage,
      },
      {
        path: 'invoices',
        name: 'bo_invoices',
        props: route => ({ total_view: true }),

        component: InvoicesView,
      },
      {
        path: 'users',
        name: 'bo_users',
        component: UsersView,
      },
      {
        path: 'fiu-templates',
        name: 'fiu-templates',
        component: FIUTemplaces,
      },
      {
        path: 'currency-rates',
        name: 'currency_rates',
        component: CurrencyView,
      },
      {
        path: 'platform-control',
        name: 'platform-control',
        component: PlatofrmControlView,
      },
      {
        path: 'terms-admin',
        name: 'terms-admin',
        component: TermsPage,
      },
      {
        path: 'logs',
        name: 'logs',
        component: Logs,
      },
      {
        path: 'logs/:date',
        name: 'logs_files',
        props: route => ({ date: route.params.date }),
        component: LogsPeriod
      },
      {
        path: 'agreements',
        name: 'agreements',
        component: Agreements,
      }
    ]
  },
  {
    path: '/profile-settings',
    name: 'profile-settings',
    component: UserProfile
  },
  {
    path: '/help-center',
    name: 'help-center',
    component: SupportTicket
  },
  {
    path: '/user-management',
    name: 'user-management',
    component: UserManagementView,
  },
  {
    path: '/invoices',
    name: 'invoices',
    component: InvoicesView,
  },
  {
    path: '/user-management',
    name: 'user-management',
    component: UserManagementView,
  },
  {
    path: '/user-management/users/:id/',
    name: 'company_users',
    props: true,
    component: userViewNormal,
  },
  {
    path: '/help-center/:id',
    name: 'single_ticket',
    props: true,
    component: TicketView,
  },
  {
    path: '/kyc',
    name: 'kyc',
    component: KYCSection,
    children: [
      {
        path: 'change-log',
        name: 'change-log',
        props: {
          view: 'forHistory'
        },
        component: ActionRequired,
      },
      {
        path: 'workflow',
        name: 'workflow',
        props: {
          view: 'forConfirmation'
        },
        component: ActionRequired,
      },
      {
        path: 'clients/',
        name: 'clients',
        component: ClientPage,
      },
      {
        path: ':id(\\w{24})/due-diligence/:item_id',
        name: 'due-diligence-item',
        props: route => ({ 
          item_id: route.params.item_id,
          id: route.params.id, 
        }),
        component: DueDiligence,
      },
      {
        path: ':id(\\w{24})/',
        name: 'client-item',
        props: route => ({ id: route.params.id }),
        component: KYCView
      }, 
      {
        path: ':id(\\w{24})/transaction-profile/',
        name: 'transaction-profile',
        props: route => ({ id: route.params.id, kycView: 'forTransactionProfile' }),
        component: KYCView
      },
      {
        path: ':id(\\w{24})/corporate/',
        name: 'corporate',
        props: route => ({ id: route.params.id, kycView: 'forCorporate' }),
        component: KYCView
      }, 
      {
        path: ':id(\\w{24})/due-diligence/',
        name: 'due-diligence',
        props: route => ({ id: route.params.id, kycView: 'forCorporate' }),
        component: DueDiligenceList
      },
      {
        path: 'tasks/',
        name: 'general-tasks',
        component: TaskList
      },
      {
        path: ':id(\\w{24})/tasks/',
        name: 'tasks',
        props: route => ({ id: route.params.id }),
        component: TaskList
      },
      {
        path: ':id(\\w{24})/tasks/:task_id',
        name: 'task-view',
        props: route => ({ id: route.params.id, task_id: route.params.task_id }),
        component: TaskView
      },
      {
        path: ':id(\\w{24})/account-holder/',
        name: 'account-holder',
        props: route => ({ id: route.params.id, kycView: 'forAccountHolder' }),
        component: KYCView
      }, 
      {
        path: ':id(\\w{24})/shareholders/',
        name: 'shareholder',
        props: route => ({ id: route.params.id, kycView: 'forShareholder' }),
        component: KYCView
      }, 
      {
        path: ':id(\\w{24})/managing-directors/',
        name: 'managing-director',
        props: route => ({ id: route.params.id, kycView: 'forMD' }),
        component: KYCView
      }, 
      {
        path: ':id(\\w{24})/workflow/',
        name: 'workflow-item',
        props: route => ({ 
          id: route.params.id, 
          view: 'forConfirmation' 
        }),
        component: ActionRequired,
      },
      {
        path: ':id(\\w{24})/workflow/:item_id',
        name: 'workflow-item-inner',
        props: route => ({ 
          item_id: route.params.item_id,
          id: route.params.id, 
          view: 'forConfirmation'
        }),
        component: ActionRequired,
      },
      {
        path: ':id(\\w{24})/change-log/',
        name: 'change-log-item',
        props: route => ({ id: route.params.id, view: 'forHistory' }),
        component: ActionRequired,
      },
      {
        path: ':id(\\w{24})/change-log/:item_id',
        name: 'change-log-item-inner',
        props: route => ({ 
          id: route.params.id, view: 'forHistory',
          item_id: route.params.item_id
        }),
        component: ActionRequired,
      },
      {
        path: ':id(\\w{24})/document-history',
        name: 'document-history',
        props: route => ({ id: route.params.id }),
        component: SnapshotView
      },
      {
        path: ':id(\\w{24})/subsidiary',
        name: 'subsidiary',
        props: route => ({ id: route.params.id }),
        component: SubsidiaryView,
      },
      {
        path: ':id(\\w{24})/sanction-screening-lookups',
        name: 'sanction-screening-lookups',
        props: route => ({ id: route.params.id }),
        component: SanctionsView
      },
      {
        path: ':id(\\w{24})/sanction-screening-lookups/:sanction_id/',
        name: 'sanction-screening-item',
        props: route => ({ id: route.params.id, sanction_id: route.params.sanction_id }),
        component: SanctionView,
      },
    ]
  },
  {
    path: '/due-diligence',
    name: 'due-diligence-no-company',
    component: DueDiligenceSection,
    children: [
      {
        path: '',
        name: 'due-diligence-no-company-list',
        props: route => ({ id: null, kycView: 'forCorporate' }),
        component: DueDiligenceList
      },
      {
        path: ':item_id',
        name: 'due-diligence-item-no-company',
        props: route => ({ 
          item_id: route.params.item_id,
        }),
        component: DueDiligence,
      }
    ]
  },
  {
    path: '/sanction-screening',
    name: 'sanction-screening-no-company',
    component: SanctionScreeningSection,
    children: [
      {
        path: '',
        name: 'sanction-screening-no-company-list',
        props: route => ({ id: null }),
        component: SanctionsView
      }
    ]
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterVue
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ResetPasswordView
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/wallet',
    name: 'wallet',
    component: WalletView
  },
  {
    path: '/verify',
    name: 'verify',
    component: VerifyView
  },
  {
    path: '/demo',
    name: 'demo',
    component: DemoPage,
  },
  {
    path: '/terms-and-conditions',
    name: 'terms',
    component: TermsUser,
    props: routere => ({ view: 'terms' })
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: TermsUser,
    props: routere => ({ view: 'privacy' })
  },
    {
    path: '/terms-of-use',
    name: 'terms-of-use',
    component: TermsUser,
    props: routere => ({ view: 'terms-of-use' })
  },


  {
    path: '/fiu',
    name: 'fiu',
    component: FiuSection,
    children: [
      {
        path: 'file-list',
        name: 'file-list',
        component: FileListView,
      },
      {
        path: 'reports',
        name: 'reports',
        component: ReportsView,
      },
      {
        path: 'user-info',
        name: 'user-info',
        component: UserInfo,
      },
      {
        path: 'player-data',
        name: 'player-data',
        component: PlayerData,
      },
      {
        path: 'dashboard',
        name: 'fiu-dashboard',
        component: UsageFIU,
      },
      {
        path: 'templates',
        name: 'available-templates',
        component: userFiuTemplates,
      },
      {
        path: 'drive',
        name: 'drive',
        component: () => import(/* webpackChunkName: "drive" */ '../views/DriveView.vue'),
      },
      {
        path: 'drive/folders/:folderId',
        name: 'drive-folder',
        component: () => import(/* webpackChunkName: "drive" */ '../views/DriveView.vue'),
      },
      {
        path: 'drive/sheets/:id',
        name: 'drive-sheet',
        component: () => import(/* webpackChunkName: "drive" */ '../views/SheetView.vue'),
      },
      {
        path: 'convert',
        name: 'convert',
        component: () => import(/* webpackChunkName: "about" */ '../views/ConverFileView.vue')
      },
    ]
  },
  {
    path: '/',
    name: '',
    component: HomePage
  },
  
  {
    path: '/fill-due-diligence/',
    name: 'fill-due-diligence',
    component: DueDiligence,
  },
]



const router = createRouter({
  mode: 'history',
  base: '/',
  history: createWebHistory(),
  routes
})

export default router
